import { Box, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  border: '1px solid',
  borderColor: theme.palette.grey[500],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  minHeight: 100,
  marginTop: theme.spacing(4),
}));

const LoadingCard = styled(Box)(({ theme }) => ({
  width: 20,
  height: 20,
  border: '2px solid',
  borderColor: theme.palette.grey[400],
  borderTopColor: theme.palette.primary.main,
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
}));

export function LoadingShippingOptionCard() {
  return (
    <Container>
      <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <LoadingCard component="span" />
        Loading options...
      </Typography>
    </Container>
  );
}

export default LoadingShippingOptionCard;
